/**
 * Border radius tokens.
 * Larger radii for a premium, modern feel (inspired by Whop).
 */

export const borderRadius = {
  none: '0',
  sm: '0.25rem',
  // 4px
  md: '0.5rem',
  // 8px
  lg: '0.75rem',
  // 12px (cards, containers)
  xl: '1rem',
  // 16px
  '2xl': '1.25rem',
  // 20px
  full: '9999px',
};
